import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AppInsightsService } from '../app-insights/app-insights.service';
import { environment } from '../../../../environments/environment';
@Injectable({
  providedIn: 'root',
})
export class GlobalErrorHandlerService implements ErrorHandler {
  router = inject(Router);
  appInsightsService = inject(AppInsightsService);

  handleError(error: unknown): void {
    // if unauthorized error, can be due to expired, revoked or invalid token
    if (error instanceof HttpErrorResponse && error.status === 401) {
      // local store clear
      localStorage.clear();
      this.router.navigate([`/login`]);
    }
    if (environment.production) {
      if (error instanceof HttpErrorResponse && error.status !== 401) {
        // API errors are already logged server-side; use the API-provided error ID
        const errorId = error.error?.errorId || '';
        this.router.navigate([`/error`], { queryParams: { id: errorId } });
      } else if (error instanceof Error) {
        const errorId = crypto.randomUUID();
        this.appInsightsService.logError(error, {
          errorId,
          source: 'Frontend - Code Error',
          name: error.name,
          message: error.message,
          cause: error.cause,
          stack: error.stack,
        });
        // this.router.navigate([`/error`], { queryParams: { id: errorId } });
      }
    } else {
      console.error(error);
    }
  }
}
